import * as React from "react";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxhook";
import {
  getSendingFullDocument,
  getuser,
  sendingfulldocument,
} from "../../redux/slices/userSlice";
import {
  getSelectedIndexes,
  updateIndexes,
} from "../../redux/slices/conversationSlice";

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 52,
  height: 26,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="-50 -20 600 600"><path fill="${encodeURIComponent(
          "#fff"
        )}" d="M499.469,44.344c0,0-44.953,0-99.219,0c-29,0.063-58.484,6.375-85.219,17.844 c-22.219,9.516-42.578,22.516-59.031,38.609c-16.531-16.094-36.875-29.094-59.031-38.609 c-26.734-11.469-56.234-17.781-85.219-17.844h-70c-18.031,0-29.219,0-29.219,0H0v357.344h12.531c0,0,11.188,0,29.219,0h70 c25.297,0,51.656,5.641,75.313,15.781c22.172,9.453,43.234,23.875,57.031,38.938c0.953,1.063,9.281,10.109,9.281,10.109 c0.672,0.734,1.625,1.141,2.625,1.141c0.984,0,1.938-0.406,2.625-1.141c0,0,8.313-9.047,9.266-10.109 c13.797-15.063,34.875-29.484,56.969-38.938c23.719-10.141,50.094-15.781,75.391-15.781c54.266,0,99.219,0,99.219,0H512V44.344 H499.469z M243.469,422.047c-13.828-11.141-29.688-20.359-46.5-27.609c-26.734-11.406-56.234-17.781-85.219-17.781H25.031V69.375 h86.719c25.297,0,51.656,5.703,75.313,15.844c22.172,9.391,41.875,22.734,56.406,38.563V422.047z M486.953,376.656H400.25 c-29,0-58.484,6.375-85.219,17.781c-16.906,7.25-32.688,16.469-46.516,27.531V123.781c14.531-15.828,34.25-29.172,56.344-38.563 c23.719-10.141,50.094-15.844,75.391-15.844h86.703V376.656z"/><path fill="${encodeURIComponent(
          "#fff"
        )}" d="M75.781,133.656v14.203h41.125c30.031,0,61.344,7.609,87.188,20.516v-15.609 c-26.484-12.141-57.234-19.109-87.188-19.109H75.781z"/></svg>')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#aab4be",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme.palette.primary.main,
    width: 25,
    height: 25,
    "&::before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        "#fff"
      )}" d="M6 7H18V9H6V7Z"/><path fill="${encodeURIComponent(
        "#fff"
      )}" d="M6 11H18V13H6V11Z"/><path fill="${encodeURIComponent(
        "#fff"
      )}" d="M18 15H6V17H18V15Z"/></svg>')`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
    borderRadius: 20 / 2,
  },
}));

export default function ProModeSwitch() {
  const dispatch = useAppDispatch();

  const toggle = useAppSelector(getSendingFullDocument);
  const user = useAppSelector(getuser);
  const selectedIndexes = useAppSelector(getSelectedIndexes);

  return (
    <FormGroup>
      <FormControlLabel id="top"
        control={
          <MaterialUISwitch
            sx={{ m: 1 }}
            onChange={(e) => {
              if (e.target.checked) {
                dispatch(sendingfulldocument(true));
                if (selectedIndexes.length > 0) {
                  dispatch(updateIndexes([selectedIndexes[0]]));
                }
              } else {
                dispatch(sendingfulldocument(false));
              }
            }}
            checked={toggle}
          />
        }
        label={
          toggle
            ? "Sending full document"
            : `${user.chunk_size} Top Ranked Pages`
        }
      />
    </FormGroup>
  );
}
